import { HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { ServicesNames } from "@core/enums";
import { Store } from "@ngrx/store";

import { selectIdEmpleado, selectIdTransaction } from "@store/index";



export const updateRequestBodyInterceptor: HttpInterceptorFn = (req, next) => {
  const clonedRequest = req.clone();
  if (req.method === 'GET' || notUpdatePayloadInServices(clonedRequest)) return next(clonedRequest);

  const store = inject(Store);


  const getBody: any = clonedRequest.body || {};

  const getIdTransaction = store.selectSignal(selectIdTransaction);
  const getIdEmpleado = store.selectSignal(selectIdEmpleado);


  let body = {
    ...getBody,
    idTransaccion: getIdTransaction(),
    payload: {
      idTransaccion: getIdTransaction(),
      agenteId: getIdEmpleado(),
      ...getBody?.payload,
    }
  }

  if (isPayloadStringType(clonedRequest)) {
    body = {
      ...getBody,
      idTransaccion: getIdTransaction(),
      payload: ''
    }
  }

  const modifiedRequest = req.clone({
    body
  })

  return next(modifiedRequest);
}


function notUpdatePayloadInServices(request: HttpRequest<unknown>): boolean {
  const filteredRequests = [
    ServicesNames.CAROUSEL,
    ServicesNames.LOGIN,
    ServicesNames.VALIDAR_DATOS_URL,
    ServicesNames.REGISTRAR_CLIENTE,

    ServicesNames.GET_CATALOGOS,
    ServicesNames.RENAPO,

    ServicesNames.MOTOR_CALCULO,
    ServicesNames.API_DESCUENTOS,
    ServicesNames.CREAR_SESSION,
    ServicesNames.MOTIVOS_CANCELACION,

    'registrarCliente',
    'getPreGuardado',
    '/gestion/ap/renovacion/isrenovacion',
    'queryAvailableBillCycle',
    'getCustomerBasicInfo',
    'pac/generarPrestamo',
    'solicitaCuentaBES',
    'terminaFlujo',
    'consultaUsuarios',
    'generaTokenService',
    'actualizaContactoCliente'
  ];

  return filteredRequests.some(serviceName => request.url.includes(serviceName));
}

function isPayloadStringType(request: HttpRequest<unknown>): boolean {
  const filteredRequest = [
    'getEnvioDomicilio',
    'getLogLambda',
    'refreshToken'
  ];

  const urlRequest = request.url;

  for (let i = 0; i < filteredRequest.length; i++) {
    if (urlRequest.includes(filteredRequest[i])) {
      return true;
    }
  }

  return false;
}
